<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #AC8400;">Cash Winners</h1>
    </div>

    <!-- Breadcrumbs -->
    <div style="padding: 10px; background-color: #F2F2F2">
      <router-link to="/dashboard">Dashboard</router-link>
      /
      <b>{{ lps() }}</b>
      /
      <b>Cash Winners</b>
    </div>
    <!-- End of breadcrumbs -->

    <div class="separator-breadcrumb border-top"></div>

    <div class="row mb-4">
      <div class="col-md-12 mb-4">
        <!-- Active -->
        <div class="card text-left">
          <div class="card-body">
            <div class="row">
              <div class="col-6 text-left">
                <h4 class="card-title mb-3">Event List</h4>
              </div>

              <div class="col-6 text-right">
                <router-link
                  :to="{ name: 'add-event-winner' }"
                  type="button"
                  class="btn btn-primary"
                  style="margin-bottom: 20px; "
                  >Add New Event
                </router-link>
              </div>

            </div>


            <!-- <div class="btn-group mb-4" role="group" v-for="(button, index) in buttons" :key="index">
              <button class="btn btn-secondary" id="btn-inactive" :press.sync="button.status"
                :class="{ 'change-background': button.status }" @click="onPressBtn(index)" type="button">
                {{ button.name }}
              </button>
            </div> -->

            <div class="row">
              <div class="col-6">
                <label><b>Date From</b></label>
                <input class="form-control" type="date" v-model="date_from" />
              </div>
              <div class="col-6">
                <label><b>Date To</b></label>
                <input class="form-control" type="date" v-model="date_to" />
              </div>
            </div>
            <br />

            <div class="row">
              <!-- <div class="text-left col-6">
                <json-excel
                  class="btn btn-rounded btn-primary mr-1"
                  style="width: 150px"
                  :fetch="CallBackData"
                  :fields="json_fields"
                  type="csv"
                  worksheet="My Worksheet"
                  name="Award Point.csv"
                >
                  Excel
                </json-excel>
                <button
                  class="btn btn-rounded btn-primary"
                  style="width: 150px"
                  @click="toPDF()"
                >
                  PDF
                </button>
              </div> -->
              <div class="text-right col-12">
                <button
                  class="btn btn-rounded btn-primary mr-1"
                  style="width: 150px"
                  @click="filterDate()"
                >
                  Submit
                </button>
                <button type="button" class="btn btn-rounded btn-primary" style="width: 150px" @click="reset()">
                  Reset
                </button>
              </div>
            </div>

            <br />
            <div class="input-group mb-4 d-flex flex-row-reverse p2">
              <button type="button" class="btn btn-primary mr-1" @click="filterSearch">
                <i class="fas fa-search"></i>
              </button>
              <div class="form-outline mr-1">
                <input type="input" class="form-control" v-model="search"/>
              </div>
            </div>

            
            <div class="table-responsive">
              <!-- All -->
              <table
                id="vendor_tbl"
                class="display table table-striped table-bordered"
                style="width:100%; text-align: center;"
              >
                <thead>
                  <tr>
                    <th>Event Name</th>
                    <th>Date</th>
                    <th>Pending Info</th>
                    <th>Submitted Info</th>
                    <th>Paid</th>
                    <th>Expired</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody v-if="events.length < 1">
                  <tr>
                    <td colspan="7">No Data</td>
                  </tr>
                </tbody>
                <tbody>
                  <tr v-for="(event, index) in events" :key="index">
                    <td>{{event.name}}</td>
                    <td>{{event.created_at}}</td>
                    <td>{{event.pending_info}}</td>
                    <td>{{event.submitted_info}}</td>
                    <td>{{event.paid}}</td>
                    <td>{{event.expired}}</td>
                    <td>
                      <router-link
                        :to="{ name: 'view-event-winner', params: {event_id: event.id, event_name: event.name} }"
                        type="button"
                        class="btn btn-primary btn-block btn-rounded"
                        style="margin-bottom: 20px;"
                        >View
                      </router-link>
                    </td>
                    
                  </tr>
                </tbody>
              </table>
              <pagination
                v-model="pageInfo.current_page"
                :per-page="pageInfo.per_page"
                :records="pageInfo.total"
                @paginate="handlePageChange"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from "axios";
import Pagination from "vue-pagination-2";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import JsonExcel from "vue-json-excel";
import { getRequest } from "@/services/RequestService";
import { jsPDF } from "jspdf";
import autoTable from 'jspdf-autotable';

export default {
  name: "cash-winner",
  components: {Pagination, JsonExcel},

  data() {
    return {
      events: [],
      loadApi: `/loyalty/prize`,
      signApi: '?',
      downloadApi: ``,

      pageInfo: {
        current_page: 1,
        next_page_url: null,
        previous_page_url: null,
        total: 0,
        count: 0,
        per_page: 0,
        last_page: 0
      },

      date_from: null,
      date_to: null,
      search: null,

      json_fields: {
        "Date Earned": "created_at",
        "Account Number": "account_number",
        "IC Number": "ic_number",
        "Name": "name",
        "Mobile Number": "mobile_number",
        "Descriptions": "description",
        "Points Earned": "point",
        "Expiry Date": "expiry_date",
        "Awarded By": "awarded_by"
      },
      json_data: [],
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],

      buttons: [
        { status: true, name: "All" },
        { status: false, name: "Pending" },
        { status: false, name: "Submitted" },
        { status: false, name: "Paid" },
        { status: false, name: "Expired" },
      ],
    };
  },

  methods: {
    async loadData() {

      this.loadApi = `/loyalty/prize`;
      this.signApi = `?`;

      try {
        let res = await getRequest(this.loadApi);

        this.events = res.data.success ? res.data.data : [];

      } catch (e) {
        console.log(e)
      }
    },

    async loadDataOnChange() {
      try {
        let res = await getRequest(this.loadApi);

        this.events = res.data.success ? res.data.data : [];

      } catch (e) {
        console.log(e)
      }
    },

    async handlePageChange(page) {
      try {
        let res = await getRequest(this.loadApi +`${this.signApi}page=${page}`);

        this.points =  res.data.data.awarded_points;
        this.pageInfo = res.data.data.pagination;

      } catch (e) {
        console.log(e)
      }

    },

    async filterDate() {
      this.loadApi = `/loyalty/prize?date_from=${this.date_from}&date_to=${this.date_to}`;
      this.signApi = `&`;

      try {
        let res = await getRequest(this.loadApi);

        this.events = res.data.success ? res.data.data : [];

      } catch (e) {
        console.log(e)
      }
    },

    async filterSearch() {
      this.loadApi = `/loyalty/prize?search=${this.search}`;
      this.signApi = `&`;

      try {
        let res = await getRequest(this.loadApi);

        this.events = res.data.success ? res.data.data : [];

      } catch (e) {
        console.log(e)
      }
    },

    async CallBackData() {
      // clear json_data
      this.json_data = [];

      let res = await getRequest(this.downloadApi);

      for(let i = 0; i < res.data.data.length; i++) {
        this.json_data.push({
          created_at: res.data.data[i].created_at,
          account_number: res.data.data[i].customer.account_number,
          ic_number: res.data.data[i].customer.ic_number,
          name: res.data.data[i].customer.name,
          mobile_number: res.data.data[i].customer.mobile_number,
          description: res.data.data[i].description,
          point: res.data.data[i].point,
          expiry_date: res.data.data[i].expiry_date,
          awarded_by: res.data.data[i].awarded_by.name
        });
      }

      return this.json_data;
    },

    async toPDF() {
      let datas = await this.CallBackData();

      const new_datas = datas.map(element => Object.values(element));

      let doc = new jsPDF({ putOnlyUsedFonts: true, orientation: "landscape" });
      
      autoTable(doc, {
        head: [['Date Earned', 'Account Number', 'IC Number', 'Name', 'Mobile Number', 'Description', 'Points', 'Expiry Date', 'Awarded By']],
        body: new_datas,
      });

      doc.save("Award Point.pdf");
    },

    async reset() {
      this.date_from = this.date_to = null;
      this.loadData();
    },

    lps() {
      return this.$lps();
    }

    // async onPressBtn(int) {
    //   this.buttons.forEach((button, index) => {
    //     button.status = int === index;
    //   });

    //   this.checkButtonStatus();
    // },

    // async checkButtonStatus() {
    //   if(this.buttons[0].status) {
    //     this.loadApi = `/loyalty/prize`;
    //     this.signApi = `?`;
    //     this.loadDataOnChange()
    //   } else if (this.buttons[1].status) {
    //     this.loadApi = `/loyalty/prize?status=0`;
    //     this.signApi = `&`;
    //     this.loadDataOnChange()
    //   } else if (this.buttons[2].status) {
    //     this.loadApi = `/loyalty/prize?status=1`;
    //     this.signApi = `&`;
    //     this.loadDataOnChange()
    //   } else if (this.buttons[3].status) {
    //     this.loadApi = `/loyalty/prize?status=2`;
    //     this.signApi = `&`;
    //     this.loadDataOnChange()
    //   } else {
    //     this.loadApi = `/loyalty/prize?status=3`;
    //     this.signApi = `&`;
    //     this.loadDataOnChange()
    //   }
    // },
  },

  async created() {
    await this.loadData();
  },

};
</script>

<style>
.change-background {
  background-color: #5f5f5f;
  color: white;
}
</style>
